import { render, staticRenderFns } from "./JoppdAIndex.vue?vue&type=template&id=3e2f34f7&scoped=true"
import script from "./JoppdAIndex.vue?vue&type=script&lang=js"
export * from "./JoppdAIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2f34f7",
  null
  
)

export default component.exports